import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export const generatePDF = async (elementToPrintRef) => {

    try {
        if (!elementToPrintRef.current) {
            throw new Error(`Element reference is not valid`);
        }

        const element = elementToPrintRef.current;

        // Find all <hr> elements in the content
        const hrElements = Array.from(element.querySelectorAll("hr"));
        const pdf = new jsPDF({
            orientation: "portrait",
            unit: "px",
            precision: 5,
            
        });

        const margin = 20;

        // Function to process each part of the document
        const processSection = async (startElement, endElement) => {
            const startOffset = startElement.offsetTop - 60;
            const endOffset = endElement ? endElement.offsetTop - 60 : element.scrollHeight;
            const sectionHeight = endOffset - startOffset;

            const canvas = await html2canvas(element, {
                scrollY: -window.scrollY, // Account for scrolled positions
                height: endElement ? sectionHeight - endElement.offsetHeight : sectionHeight, // Handle null `endElement`
                y: startOffset,
                useCORS: true, // Enable cross-origin requests for resources
                scale: 2,
                logging: true,
            });

            const imgData = canvas.toDataURL("image/jpeg", 0.5);
            const imgWidth = pdf.internal.pageSize.getWidth() - margin * 2;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.internal.pageSize.height = imgHeight + margin * 2; // Set dynamic page height
            pdf.addImage(imgData, "JPEG", margin, margin, imgWidth, imgHeight);
        };

        // Iterate through sections divided by <hr>
        let startElement = element;
        for (let i = 0; i <= hrElements?.length; i++) {
            const endElement = hrElements[i] || null; // Use null for the last section
            if (i > 0) pdf.addPage(); // Add a new page for each section except the first
            await processSection(startElement, endElement);
            startElement = endElement;
        }

        pdf.save("print.pdf");
        return true;
    } catch (error) {
        console.error("Error generating PDF:", error);
        return false;
    }
};